import '../../../App.css';
import './Profile.css';
import { useEffect, useState, useContext } from 'react';
import { Modal, Input, Form, Button } from 'antd';
import { TfiPencilAlt } from "react-icons/tfi";
import Appconfig from '../../../config/config'
import axios from 'axios';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { WebSocketContext } from '../../../context/websocket';

function Profile({ user_id }) {
    const userInfos = JSON.parse(localStorage.getItem('userdata'))
    const targetUserId =
        user_id || userInfos?._id;
    const websocket = useContext(WebSocketContext);

    const [commisionForm] = Form.useForm();
    const [rollingForm] = Form.useForm();
    const [exposerLimitForm] = Form.useForm();
    const [phoneNoForm] = Form.useForm();
    const [passwordForm] = Form.useForm();

    const [userInfo, setUserInfo] = useState('')
    const [commissionModal, setCommissionModal] = useState(false)
    const [rollingModal, setRollingModal] = useState(false)
    const [exposureLimitModal, setExposureLimitModal] = useState(false)
    const [phoneNoModal, setPhoneNoModal] = useState(false)
    const [passwordModal, setPasswordModal] = useState(false)
    function getUsersData() {

        if (!targetUserId) {
            return;
        }

        var data = JSON.stringify({
            user_id: targetUserId,
        });
        var config = {
            method: "post",
            url: `${Appconfig.apiUrl}users/getOneUserById`,
            headers: {
                "Content-Type": "application/json",
            },
            data: data,

        };
        axios(config)
            .then(function (response) {
                if (response.data.resultData) {
                    setUserInfo(response.data.resultData)
                }
            })
            .catch(function (error) {
                //            console.log(error);
            });
    }
    useEffect(() => {
        if (targetUserId) {
            getUsersData();
        }
    }, [targetUserId]);

    const handleEditCommission = async (values) => {


        if (userInfos.password == values.password) {
            var data = JSON.stringify({
                "user_id": user_id,
                "UpdateField": {
                    "commission": values.commission
                }
            });
            var config = {
                method: 'post',
                url: `${Appconfig.apiUrl}users/updateUserInfo`,
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            axios(config)
                .then(function (response) {
                    if (response.data.result != '0') {
                        setCommissionModal(false)
                        getUsersData()
                        commisionForm.resetFields();
                        NotificationManager.success('Commission Updated Successfully.', '', 3000);
                    }
                    else {
                        console.log(response)
                        NotificationManager.error(`${response.data.resultMessage}`, '', 3000);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        } else {
            NotificationManager.error('Password Not Matched With Login Id', '', 3000);

        }
    }
    const onCommissionFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    const handleEditRollingCommission = async (values) => {

        if (userInfos.password == values.password) {

            var data = JSON.stringify({
                "user_id": user_id,
                "UpdateField": {
                    "rolling_commission_fancy": values.rolling_commission_fancy,
                    "rolling_commission_matka": values.rolling_commission_matka,
                    "rolling_commission_casino": values.rolling_commission_casino,
                    "rolling_commission_sportbook": values.rolling_commission_sportbook,
                    "rolling_commission_bookmaker": values.rolling_commission_bookmaker,
                    "rolling_commission_virtualsport": values.rolling_commission_virtualsport,
                }
            });
            // console.log(data)
            // return false
            var config = {
                method: 'post',
                url: `${Appconfig.apiUrl}users/updateUserInfo`,
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            axios(config)
                .then(function (response) {
                    console.log(response)
                    if (response.data.result != '0') {
                        setRollingModal(false)
                        getUsersData()
                        rollingForm.resetFields();
                        NotificationManager.success('Rolling Commission Updated Successfully.', '', 3000);
                    }
                    else {
                        console.log(response)
                        NotificationManager.error(`${response.data.resultMessage}`, '', 3000);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        } else {
            NotificationManager.error('Password Not Matched With Login Id', '', 3000);

        }
    }
    const onRollingnFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    const handleExposerLimit = async (values) => {

        if (userInfos.password == values.password) {
            var data = JSON.stringify({
                "user_id": user_id,
                "UpdateField": {
                    "exposer_limit": values.exposer_limit
                }
            });
            var config = {
                method: 'post',
                url: `${Appconfig.apiUrl}users/updateUserInfo`,
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            axios(config)
                .then(function (response) {
                    console.log(response)
                    if (response.data.result != '0') {

                        if (websocket && websocket.readyState) {
                            console.log("Sending user block via WebSocket...");
                            websocket.send(JSON.stringify({
                                action: "USER_BLOCK_UPDATE",
                                data: {
                                    user_id: userInfo?._id,
                                }
                            }));
                        }

                        NotificationManager.success('Exposer Limit Updated Successfully.', '', 3000);
                        setExposureLimitModal(false)
                        getUsersData()
                        exposerLimitForm.resetFields();
                    }
                    else {
                        console.log(response)
                        NotificationManager.error(`${response.data.resultMessage}`, '', 3000);
                    }


                })
                .catch(function (error) {
                    console.log(error);
                });
        } else {
            NotificationManager.error('Password Not Matched With Login Id', '', 3000);

        }
    }
    const handleChangePhone = async (values) => {

        if (userInfos.password == values.password) {
            var data = JSON.stringify({
                "user_id": user_id,
                "UpdateField": {
                    "phone": values.phone
                }
            });
            var config = {
                method: 'post',
                url: `${Appconfig.apiUrl}users/updateUserInfo`,
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            axios(config)
                .then(function (response) {
                    console.log(response)
                    if (response.data.result != '0') {
                        NotificationManager.success('Mobile Number Updated Successfully.', '', 3000);
                        setPhoneNoModal(false)
                        getUsersData()
                        phoneNoForm.resetFields();
                    }
                    else {
                        console.log(response)
                        NotificationManager.error(`${response.data.resultMessage}`, '', 3000);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        } else {
            NotificationManager.error('Password Not Matched With Login Id', '', 3000);

        }
    }
    const handleChangePassword = async (values) => {

        if (userInfos.password == values.password) {

            var data = JSON.stringify({
                "user_id": user_id,
                "UpdateField": {
                    "password": values.new_password,
                },
                "updateHistroy": {
                    'master_id': userInfo.master_id,
                    'masters': userInfo.masters,
                    'name': userInfos?.name,
                    'user_name': userInfos?.user_name,
                    'user_type': userInfos?.user_type
                }
            });
            // console.log('data', data)
            // return false;
            var config = {
                method: 'post',
                url: `${Appconfig.apiUrl}users/auraUpdateUserInfo`,
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            axios(config)
                .then(function (response) {
                    console.log(response)
                    if (response.data.result != '0') {
                        NotificationManager.success('Password Changed Successfully.', '', 3000);
                        setPhoneNoModal(false)
                        setPasswordModal(false)
                        getUsersData()
                        phoneNoForm.resetFields();

                        if (websocket && websocket.readyState) {
                            console.log("Sending user block via WebSocket...");
                            websocket.send(JSON.stringify({
                                action: "USER_BLOCK_UPDATE",
                                data: {
                                    user_id: userInfo?._id,
                                }
                            }));
                        }
                    }
                    else {
                        console.log(response)
                        NotificationManager.error(`${response.data.resultMessage}`, '', 3000);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
        else {
            NotificationManager.success('Password Not Matched With Login Id.', '', 3000);

        }
    }
    return (
        <>
            <NotificationContainer />
            <div className="profile-page">
                <section className="profile-card">
                    <header className="profile-card-header">
                        <div className="profile-card-header-content">
                            <span
                                className="profile-card-icon"
                                aria-hidden="true"
                            >
                                👤
                            </span>

                            <div>
                                <h2>Account Details</h2>

                                <p>
                                    View and update user account
                                    information
                                </p>
                            </div>
                        </div>
                    </header>

                    <div className="profile-card-body">
                        <dl className="profile-details-grid">
                            <dt className="profile-detail-label">
                                Name
                            </dt>

                            <dd className="profile-detail-value">
                                {userInfo && userInfo.user_name}
                            </dd>
                            <dt className="profile-detail-label">
                                Commission
                            </dt>

                            <dd className="profile-detail-value profile-detail-editable">
                                {userInfo && userInfo.commission}
                                <button
                                    type="button"
                                    className="profile-edit-button"
                                    onClick={() =>
                                        setCommissionModal(true)
                                    }
                                    aria-label="Edit commission"
                                >
                                    <svg
                                        className="profile-edit-icon"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        aria-hidden="true"
                                    >
                                        <path d="M441 58.9L453.1 71c9.4 9.4 9.4 24.6 0 33.9L424 134.1 377.9 88 407 58.9c9.4-9.4 24.6-9.4 33.9 0zM209.8 256.2L344 121.9 390.1 168 255.8 302.2c-2.9 2.9-6.5 5-10.4 6.1l-58.5 16.7 16.7-58.5c1.1-3.9 3.2-7.5 6.1-10.4zM373.1 25L175.8 222.2c-8.7 8.7-15 19.4-18.3 31.1l-28.6 100c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l100-28.6c11.8-3.4 22.5-9.7 31.1-18.3L487 138.9c28.1-28.1 28.1-73.7 0-101.8L474.9 25C446.8-3.1 401.2-3.1 373.1 25zM88 64C39.4 64 0 103.4 0 152V424c0 48.6 39.4 88 88 88H360c48.6 0 88-39.4 88-88V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V424c0 22.1-17.9 40-40 40H88c-22.1 0-40-17.9-40-40V152c0-22.1 17.9-40 40-40H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H88z" />
                                    </svg>
                                </button>
                                <Modal
                                    title="Update Commission"
                                    className="profile-edit-modal"
                                    onCancel={() =>
                                        setCommissionModal(false)
                                    }
                                    footer={null}
                                    open={commissionModal}
                                >
                                    <div className="profile-modal-content">
                                        <div className="profile-modal-inner">
                                            <Form
                                                form={commisionForm}
                                                layout="vertical"
                                                className="profile-edit-form"
                                                name="basic"
                                                labelCol={{
                                                    span: 24,
                                                }}
                                                wrapperCol={{
                                                    span: 24,
                                                }}
                                                onFinish={handleEditCommission}
                                                onFinishFailed={onCommissionFinishFailed}
                                                autoComplete="off"
                                            >
                                                <Form.Item
                                                    label="Commission"
                                                    name="commission"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Commission is required.',
                                                        },
                                                    ]}
                                                >
                                                    <Input placeholder='Commission...' />
                                                </Form.Item>
                                                <Form.Item
                                                    name="password"
                                                    label="Your Password "
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'User Password is required.',
                                                        },
                                                    ]}
                                                >
                                                    <Input.Password placeholder='Your Password..' />
                                                </Form.Item>
                                                <Form.Item
                                                    wrapperCol={{
                                                        span: 24,
                                                    }}
                                                    className="profile-form-actions"
                                                >
                                                    <Button
                                                        type="primary"
                                                        htmlType="submit"
                                                        className="profile-save-button"
                                                    >
                                                        Update
                                                    </Button>
                                                    <Button
                                                        type="button"
                                                        className="profile-cancel-button"
                                                        onClick={() =>
                                                            setCommissionModal(false)
                                                        }
                                                    >
                                                        Cancel
                                                    </Button>
                                                </Form.Item>
                                            </Form>
                                        </div>
                                    </div>

                                </Modal>
                            </dd>
                            <dt className="profile-detail-label">
                                Rolling Commission
                            </dt>

                            <dd className="profile-detail-value profile-detail-editable">
                                <button
                                    type="button"
                                    className="profile-edit-button"
                                    onClick={() =>
                                        setRollingModal(true)
                                    }
                                    aria-label="Edit rolling commission"
                                >
                                    <svg
                                        className="profile-edit-icon"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        aria-hidden="true"
                                    >
                                        <path d="M441 58.9L453.1 71c9.4 9.4 9.4 24.6 0 33.9L424 134.1 377.9 88 407 58.9c9.4-9.4 24.6-9.4 33.9 0zM209.8 256.2L344 121.9 390.1 168 255.8 302.2c-2.9 2.9-6.5 5-10.4 6.1l-58.5 16.7 16.7-58.5c1.1-3.9 3.2-7.5 6.1-10.4zM373.1 25L175.8 222.2c-8.7 8.7-15 19.4-18.3 31.1l-28.6 100c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l100-28.6c11.8-3.4 22.5-9.7 31.1-18.3L487 138.9c28.1-28.1 28.1-73.7 0-101.8L474.9 25C446.8-3.1 401.2-3.1 373.1 25zM88 64C39.4 64 0 103.4 0 152V424c0 48.6 39.4 88 88 88H360c48.6 0 88-39.4 88-88V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V424c0 22.1-17.9 40-40 40H88c-22.1 0-40-17.9-40-40V152c0-22.1 17.9-40 40-40H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H88z" />
                                    </svg>
                                </button>
                                <Modal
                                    title={`Rolling Commission - ${userInfo.user_name
                                        }`}
                                    className="profile-edit-modal"
                                    onCancel={() =>
                                        setRollingModal(false)
                                    }
                                    footer={null}
                                    open={rollingModal}
                                >
                                    <div className="profile-modal-content">
                                        <div className="profile-modal-inner">
                                            <Form
                                                form={rollingForm}
                                                // layout="vertical"
                                                className="profile-edit-form"
                                                name="basic"
                                                labelCol={{
                                                    span: 5,
                                                }}
                                                wrapperCol={{
                                                    span: 15,
                                                }}
                                                onFinish={handleEditRollingCommission}
                                                onFinishFailed={onRollingnFinishFailed}
                                                autoComplete="off"
                                                initialValues={{
                                                    rolling_commission_fancy: userInfo.rolling_commission_fancy,
                                                    rolling_commission_matka: userInfo.rolling_commission_matka,
                                                    rolling_commission_casino: userInfo.rolling_commission_casino,
                                                    rolling_commission_sportbook: userInfo.rolling_commission_sportbook,
                                                    rolling_commission_bookmaker: userInfo.rolling_commission_bookmaker,
                                                    rolling_commission_virtualsport: userInfo.rolling_commission_virtualsport,
                                                }}
                                            >
                                                <Form.Item
                                                    label="Fancy"
                                                    name="rolling_commission_fancy"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            message: 'Commission is required.',
                                                        },
                                                    ]}
                                                >
                                                    <Input type='number' placeholder='Fancy Rolling Commission...' />
                                                </Form.Item>
                                                <Form.Item
                                                    label="Matka"
                                                    name="rolling_commission_matka"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            message: 'Commission is required.',
                                                        },
                                                    ]}
                                                >
                                                    <Input type='number' placeholder='Matka Rolling Commission...' />
                                                </Form.Item>
                                                <Form.Item
                                                    label="Casino"
                                                    name="rolling_commission_casino"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            message: 'Commission is required.',
                                                        },
                                                    ]}
                                                >
                                                    <Input type='number' placeholder='Casino Rolling Commission...' />
                                                </Form.Item>
                                                <Form.Item
                                                    label="Sportbook"
                                                    name="rolling_commission_sportbook"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            message: 'Commission is required.',
                                                        },
                                                    ]}
                                                >
                                                    <Input type='number' placeholder='Sportbook Rolling Commission...' />
                                                </Form.Item>
                                                <Form.Item
                                                    label="Bookmaker"
                                                    name="rolling_commission_bookmaker"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            message: 'Commission is required.',
                                                        },
                                                    ]}
                                                >
                                                    <Input type='number' placeholder='Bookmaker Rolling Commission...' />
                                                </Form.Item>
                                                <Form.Item
                                                    label="Virtual Sports"
                                                    name="rolling_commission_virtualsport"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            message: 'Commission is required.',
                                                        },
                                                    ]}
                                                >
                                                    <Input type='number' placeholder='Virtual Sports Rolling Commission...' />
                                                </Form.Item>
                                                <Form.Item
                                                    name="password"
                                                    label="Password "
                                                    rules={[
                                                        {
                                                            required: false,
                                                            message: 'User Password is required.',
                                                        },
                                                    ]}
                                                >
                                                    <Input.Password placeholder='Your Password..' />
                                                </Form.Item>
                                                <Form.Item
                                                    wrapperCol={{
                                                        span: 24,
                                                    }}
                                                    className="profile-form-actions"
                                                >
                                                    <Button
                                                        type="primary"
                                                        htmlType="submit"
                                                        className="profile-save-button"
                                                    >
                                                        Update
                                                    </Button>
                                                    <Button
                                                        type="button"
                                                        className="profile-cancel-button"
                                                        onClick={() =>
                                                            setRollingModal(false)
                                                        }
                                                    >
                                                        Cancel
                                                    </Button>
                                                </Form.Item>
                                            </Form>
                                        </div>
                                    </div>
                                </Modal>
                            </dd>
                            <dt className="profile-detail-label">
                                Currency
                            </dt>

                            <dd className="profile-detail-value">
                                IRP
                            </dd>
                            <dt className="profile-detail-label">
                                Exposure Limit
                            </dt>

                            <dd className="profile-detail-value profile-detail-editable">
                                {userInfo && userInfo.exposer_limit}
                                <button
                                    type="button"
                                    className="profile-edit-button"
                                    onClick={() =>
                                        setExposureLimitModal(true)
                                    }
                                    aria-label="Edit exposure limit"
                                >
                                    <svg
                                        className="profile-edit-icon"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        aria-hidden="true"
                                    >
                                        <path d="M441 58.9L453.1 71c9.4 9.4 9.4 24.6 0 33.9L424 134.1 377.9 88 407 58.9c9.4-9.4 24.6-9.4 33.9 0zM209.8 256.2L344 121.9 390.1 168 255.8 302.2c-2.9 2.9-6.5 5-10.4 6.1l-58.5 16.7 16.7-58.5c1.1-3.9 3.2-7.5 6.1-10.4zM373.1 25L175.8 222.2c-8.7 8.7-15 19.4-18.3 31.1l-28.6 100c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l100-28.6c11.8-3.4 22.5-9.7 31.1-18.3L487 138.9c28.1-28.1 28.1-73.7 0-101.8L474.9 25C446.8-3.1 401.2-3.1 373.1 25zM88 64C39.4 64 0 103.4 0 152V424c0 48.6 39.4 88 88 88H360c48.6 0 88-39.4 88-88V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V424c0 22.1-17.9 40-40 40H88c-22.1 0-40-17.9-40-40V152c0-22.1 17.9-40 40-40H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H88z" />
                                    </svg>
                                </button>
                                <Modal
                                    title={`Edit Exposure Limit - ${userInfo.user_name
                                        }`}
                                    className="profile-edit-modal"
                                    onCancel={() =>
                                        setExposureLimitModal(false)
                                    }
                                    footer={null}
                                    open={exposureLimitModal}
                                >
                                    <div className="profile-modal-content">
                                        <div className="profile-modal-inner">
                                            <Form
                                                form={exposerLimitForm}
                                                className="profile-edit-form"
                                                name="basic"
                                                labelCol={{
                                                    span: 5,
                                                }}
                                                wrapperCol={{
                                                    span: 15,
                                                }}
                                                onFinish={handleExposerLimit}
                                                onFinishFailed={onRollingnFinishFailed}
                                                autoComplete="off"
                                            >
                                                <div className="profile-current-value">
                                                    <span>Current Exposure Limit</span>

                                                    <strong>
                                                        {userInfo.exposer_limit}
                                                    </strong>
                                                </div>
                                                <Form.Item
                                                    label="New"
                                                    name="exposer_limit"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            message: 'Exposer Limit is required.',
                                                        },
                                                    ]}
                                                >
                                                    <Input type='number' />
                                                </Form.Item>
                                                <Form.Item
                                                    name="password"
                                                    label="Password "
                                                    rules={[
                                                        {
                                                            required: false,
                                                            message: 'User Password is required.',
                                                        },
                                                    ]}
                                                >
                                                    <Input.Password />
                                                </Form.Item>
                                                <Form.Item
                                                    wrapperCol={{
                                                        span: 24,
                                                    }}
                                                    className="profile-form-actions"
                                                >
                                                    <Button
                                                        type="primary"
                                                        htmlType="submit"
                                                        className="profile-save-button"
                                                    >
                                                        Update
                                                    </Button>
                                                    <Button
                                                        type="button"
                                                        className="profile-cancel-button"
                                                        onClick={() =>
                                                            setExposureLimitModal(false)
                                                        }
                                                    >
                                                        Cancel
                                                    </Button>
                                                </Form.Item>
                                            </Form>
                                        </div>
                                    </div>
                                </Modal>
                            </dd>
                            <dt className="profile-detail-label">
                                Mobile Number
                            </dt>

                            <dd className="profile-detail-value profile-detail-editable">
                                {userInfo && userInfo.phone ? userInfo.phone : 'Not Found'}
                                <button
                                    type="button"
                                    className="profile-edit-button"
                                    onClick={() =>
                                        setPhoneNoModal(true)
                                    }
                                    aria-label="Edit mobile number"
                                >
                                    <svg
                                        className="profile-edit-icon"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        aria-hidden="true"
                                    >
                                        <path d="M441 58.9L453.1 71c9.4 9.4 9.4 24.6 0 33.9L424 134.1 377.9 88 407 58.9c9.4-9.4 24.6-9.4 33.9 0zM209.8 256.2L344 121.9 390.1 168 255.8 302.2c-2.9 2.9-6.5 5-10.4 6.1l-58.5 16.7 16.7-58.5c1.1-3.9 3.2-7.5 6.1-10.4zM373.1 25L175.8 222.2c-8.7 8.7-15 19.4-18.3 31.1l-28.6 100c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l100-28.6c11.8-3.4 22.5-9.7 31.1-18.3L487 138.9c28.1-28.1 28.1-73.7 0-101.8L474.9 25C446.8-3.1 401.2-3.1 373.1 25zM88 64C39.4 64 0 103.4 0 152V424c0 48.6 39.4 88 88 88H360c48.6 0 88-39.4 88-88V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V424c0 22.1-17.9 40-40 40H88c-22.1 0-40-17.9-40-40V152c0-22.1 17.9-40 40-40H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H88z" />
                                    </svg>
                                </button>
                                <Modal
                                    title="Change Mobile Number"
                                    className="profile-edit-modal"
                                    onCancel={() =>
                                        setPhoneNoModal(false)
                                    }
                                    footer={null}
                                    open={phoneNoModal}
                                >
                                    <Form
                                        form={phoneNoForm}
                                        className="profile-edit-form"
                                        layout='vertical'
                                        name="basic"
                                        labelCol={{
                                            span: 24,
                                        }}
                                        wrapperCol={{
                                            span: 24,
                                        }}
                                        onFinish={handleChangePhone}
                                        autoComplete="off"
                                    >
                                        <div className="profile-form-grid">
                                            <div className="profile-form-field">
                                                <Form.Item
                                                    name="password"
                                                    label="Your Password "
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'User Password is required.',
                                                        },
                                                    ]}
                                                >
                                                    <Input.Password placeholder='Your Password..' />
                                                </Form.Item>
                                            </div>
                                            <div className="profile-form-field">
                                                <Form.Item
                                                    label="Mobile Number"
                                                    name="phone"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Mobile Numbe is required.',
                                                        },
                                                    ]}
                                                >
                                                    <Input type='number' placeholder='Mobile Number' />
                                                </Form.Item>
                                            </div>
                                            <div className="profile-form-action-row">
                                                <Form.Item
                                                    wrapperCol={{
                                                        span: 24,
                                                    }}
                                                    className="profile-form-actions"
                                                >
                                                    <Button
                                                        type="primary"
                                                        htmlType="submit"
                                                        className="profile-save-button"
                                                    >
                                                        Update
                                                    </Button>
                                                    <Button
                                                        type="button"
                                                        className="profile-cancel-button"
                                                        onClick={() =>
                                                            setPhoneNoModal(false)
                                                        }
                                                    >
                                                        Cancel
                                                    </Button>
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </Form>
                                </Modal>
                            </dd>
                            <dt className="profile-detail-label">
                                Password
                            </dt>

                            <dd className="profile-detail-value profile-detail-editable">
                                <span className="profile-password-mask">
                                    *********
                                </span>
                                <button
                                    type="button"
                                    className="profile-edit-button"
                                    onClick={() =>
                                        setPasswordModal(true)
                                    }
                                    aria-label="Change password"
                                >
                                    <span
                                        className="profile-edit-icon"
                                        aria-hidden="true"
                                    >
                                        <TfiPencilAlt />
                                    </span>
                                </button>
                                <Modal
                                    title="Change Password"
                                    className="profile-edit-modal"
                                    onCancel={() =>
                                        setPasswordModal(false)
                                    }
                                    footer={null}
                                    open={passwordModal}
                                >
                                    <Form
                                        form={passwordForm}
                                        className="profile-edit-form"
                                        layout='vertical'
                                        name="basic"
                                        labelCol={{
                                            span: 24,
                                        }}
                                        wrapperCol={{
                                            span: 24,
                                        }}
                                        onFinish={handleChangePassword}
                                        autoComplete="off"
                                    >
                                        <div className="profile-form-grid">
                                            <div className="profile-form-field">
                                                <Form.Item
                                                    name="password"
                                                    label="Your Password "
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'User Password is required.',
                                                        },
                                                    ]}
                                                >
                                                    <Input.Password />
                                                </Form.Item>
                                            </div>
                                            <div className="profile-form-field">
                                                <Form.Item
                                                    name="new_password"
                                                    label="New Password"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Mobile Numbe is required.',
                                                        },
                                                    ]}
                                                >
                                                    <Input.Password />
                                                </Form.Item>
                                            </div>
                                            <div className="profile-form-field">
                                                <Form.Item
                                                    name="confirm_password"
                                                    label="Confirm Password"
                                                    dependencies={['new_password']}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Please confirm your password!',
                                                        },
                                                        ({ getFieldValue }) => ({
                                                            validator(_, value) {
                                                                if (!value || getFieldValue('new_password') === value) {
                                                                    return Promise.resolve();
                                                                }
                                                                return Promise.reject(new Error('Passwords is not matched.'));
                                                            },
                                                        }),
                                                    ]}
                                                >
                                                    <Input.Password />
                                                </Form.Item>
                                            </div>
                                            <div className="profile-form-action-row">
                                                <Form.Item
                                                    wrapperCol={{
                                                        span: 24,
                                                    }}
                                                    className="profile-form-actions"
                                                >
                                                    <Button
                                                        type="primary"
                                                        htmlType="submit"
                                                        className="profile-save-button"
                                                    >
                                                        Change Password
                                                    </Button>
                                                    <Button
                                                        type="button"
                                                        className="profile-cancel-button"
                                                        onClick={() =>
                                                            setPasswordModal(false)
                                                        }
                                                    >
                                                        Cancel
                                                    </Button>
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </Form>
                                </Modal>
                            </dd>

                        </dl>
                    </div>
                </section>
            </div>
        </>
    );
}

export default Profile;
